<template>
  <div>
    <my-header></my-header>
  
    <div class="content-container-level-1">
      <h2>New gvnt contests</h2>

      <form @submit.prevent="createContestsWithConfirmation">

        <div class="mb-4">
          <h5>Start</h5>

          <b-form-datepicker
            v-model="plannedStartDate"
            :min="minPlannedStartDate"
            :start-weekday="MONDAY"
            class="mb-2"
          />

          <time-input
            v-model="plannedStartTime"
          />
        </div>

        <div class="mb-4">
          <h5>Finish</h5>

          <b-form-datepicker
            v-model="plannedFinishDate"
            :min="minPlannedFinishDate"
            :start-weekday="MONDAY"
            class="mb-2"
          />

          <time-input
            v-model="plannedFinishTime"
          />
        </div>

        <div class="mb-4">
          <h5>Cycle Duration</h5>

          <div class="container">
            <div class="row">
              <div class="col-sm">
                <h6>Hours</h6>
                <input type="number"
                  v-model="duration_h"
                />
              </div>
              <div class="col-sm">
                <h6>Minutes</h6>
                <input type="number"
                  v-model="duration_m"
                />
              </div>
              <div class="col-sm">
                <h6>Pause In Hours</h6>
                <input type="number"
                  v-model="pause_h"
                />
              </div>
              <div class="col-sm">
                <h6>Pause In Minutes</h6>
                <input type="number"
                  v-model="pause_m"
                />
              </div>
            </div>
          </div>
        </div>

        <!-- PREVIEW -->

        <div class="mb-3" v-for="(tmnt, index) in tmnts" :key="tmnt.start">
          <h5>#{{ index + 1 }}</h5>
          <table class="tmnt">
            <tr>
              <td>
                Start:
              </td>
              <td>
                {{tmnt.start | getMomentStr}}
              </td>
            </tr>
            <tr>
              <td>
                Finish:
              </td>
              <td>
                {{tmnt.finish | getMomentStr}}
              </td>
            </tr>
          </table>
        </div>

        <hr>

        <b-button :to="{name: 'contests'}">Cancel</b-button>
        <b-button type="submit" variant="primary">{{createButtonLabel}}</b-button>

        <b-button
          v-if="false"
          @click="createContestsWithConfirmation2"
        >
          {{createButtonLabel}} 2
        </b-button>
      </form>
    </div>

  </div>
</template>

<script>
import notifier from '../notifier';
import { HTTP } from '../http-common';
import MyHeader from './Header.vue';
import TimeInput from './TimeInput.vue';

import { CONTEST_TYPE_GVNT } from '../model/contest.js';

import { confirmAction } from '../service/confirm';

import { convertMomentToDataStr       } from '../util';
import { convertMomentToTimeStr       } from '../util';
import { getDurationStrBetweenMoments } from '../util';
import { convertDataStrAndTimeStrToLocalData } from '../util';

let makeTmnts = async function(thiz) {
  notifier.deleteSenderNotifications(this);
  for(let i = 0; i < thiz.tmnts.length; ++i)
  {
     let plannedStartSec  = thiz.tmnts[i].start
     let plannedFinishSec = thiz.tmnts[i].finish

     if(plannedFinishSec === plannedStartSec) {
       notifier.showError(
         'Contest duration is zero.',
         {sender: thiz},
       );
       return;
     }

     if(plannedFinishSec <= plannedStartSec) {
       notifier.showError(
         'Finish time must be after start time.',
         {sender: thiz},
       );
       return;
     }

     const data = new FormData();
     data.append('type', thiz.type);
     data.append('stime', plannedStartSec);
     data.append('ftime', plannedFinishSec);

     await HTTP.post('/contest/add', data)
     .then(response => {
       const result = response.data.result.code;

       const RESULT_SUCCESS    = 1;
       const RESULT_HAS_ACTIVE = 2;

       if(result === RESULT_SUCCESS) {
         notifier.showSuccessAfterTransition('Contest created.');
         return;
       }

       if(result === RESULT_HAS_ACTIVE) {
         notifier.showError('Can not start contest. Contest with specified type is already active.', {sender: thiz});
         return;
       }

       notifier.showError(`Unknown result code ${result}.`, {sender: thiz});
     })
     .catch(e => {
       notifier.showError(e.response.data, {sender: this});
     });
  }
  thiz.$router.push({name: 'contests'});
}

export default {
  name: 'GvntTmntAdd',

  components: {
    MyHeader,
    TimeInput,
  },

  data() {
    const now = new Date();
    const nowDateStr = convertMomentToDataStr(now);
    const nowTimeStr = convertMomentToTimeStr(now);

    const DEFAULT_DURATION_HOURS = 24;
    const DEFAULT_DURATION_MINUTES = 0;

    const finish = new Date(now.getTime());
    finish.setHours(finish.getHours() + DEFAULT_DURATION_HOURS);
    const finishDateStr = convertMomentToDataStr(finish);
    const finishTimeStr = convertMomentToTimeStr(finish);

    return {
      MONDAY: 1,

      type: CONTEST_TYPE_GVNT,

      plannedStartDate: nowDateStr,
      minPlannedStartDate: nowDateStr,
      plannedStartTime: nowTimeStr,

      plannedFinishDate: finishDateStr,
      minPlannedFinishDate: nowDateStr,
      plannedFinishTime: finishTimeStr,

      duration_h: DEFAULT_DURATION_HOURS,
      duration_m: DEFAULT_DURATION_MINUTES,
      pause_h: 0,
      pause_m: 0
    };
  },

  computed: {
    plannedStartMoment() {
      return convertDataStrAndTimeStrToLocalData(this.plannedStartDate, this.plannedStartTime);
    },

    plannedFinishMoment() {
      return convertDataStrAndTimeStrToLocalData(this.plannedFinishDate, this.plannedFinishTime);
    },

    durationStr() {
      return getDurationStrBetweenMoments(this.plannedStartMoment, this.plannedFinishMoment);
    },

    tmnts() {
      var time = this.plannedStartMoment.getTime();
      var items = [];
      if(this.duration_h == this.duration_m && this.duration_h == 0)
        return items;

      while(time < this.plannedFinishMoment) {
        var item = {};
        item.start = time / 1000;
        item.startDate = new Date(time);
        time += ((this.duration_h * 60 * 60) + (this.duration_m * 60)) * 1000;
        item.finishDate = new Date(time);
        item.finish = time / 1000;
        items.push(item);
        if(item.start == item.finish)
          break;
        time += ((this.pause_h * 60 * 60) + (this.pause_m * 60)) * 1000;
      }

      return items
    },

    createButtonLabel() {
      const contests = this.tmnts;
      if(contests === undefined || contests === null) {
        return 'Create contest';
      }
      if(contests.length === 1) {
        return 'Create contest';
      }
      return 'Create contests';
    },
  },

  methods: {
    createContestsWithConfirmation() {
      this.confirmContestsCreation(() => {
        this.createContests();
      });
    },

    // function onConfirmed()
    confirmContestsCreation(onConfirmed) {
      confirmAction(
        this,
        'Are you sure you want to create this contests {env}?',
        'Create',
        onConfirmed,
      );
    },

    createContests() {
      makeTmnts(this);
    },

    createContestsWithConfirmation2() {
      //todo: create contests in one request.
    },
  },
};
</script>

<style scoped>
.tmnt td:first-child {
  padding-right: 0.3rem;
}
</style>
